import notification from "../../../../assets/sounds/notification.mp3";

export const notificationAudio = (() => {
  const audio = new Audio(notification);
  let isPlaying = false;
  audio.onplaying = function () {
    isPlaying = true;
  };
  audio.onpause = function () {
    isPlaying = false;
  };
 // If too many notifications come in small intervals it will skip playing when its already playing & avoid throwing error in console.
  return {
    play: () => {
      if (audio.paused && !isPlaying) {
        audio.play();
      }
    },
  }
})();
